const actions = {
  SET_STATE: 'home/SET_STATE',
}

export default actions
